import React from 'react';

import CourseHeading from '../../BookLandingPageComp/landingPage/heading/CourseHeading';

type RequirementsProps = {
  items: string[];
};

const Requirements: React.FC<RequirementsProps> = ({ items }) => {
  return (
    <div className='bg-black text-white '>
      <CourseHeading heading='Requirements' />
      <ul className='space-y-2'>
        {items.map((item, index) => (
          <li
            key={`${item}-${index}`}
            className='flex items-start gap-2 text-white'
          >
            <span className='text-lg md:text-2xl  h-full flex items-start -translate-y-1.5 md:-translate-0 pl-1'>
              •
            </span>
            <span className='font-[300] text-xs md:text-sm '>{item}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Requirements;
